import { render, staticRenderFns } from "./guest.vue?vue&type=template&id=45d87748&scoped=true&"
import script from "./guest.vue?vue&type=script&lang=js&"
export * from "./guest.vue?vue&type=script&lang=js&"
import style0 from "./guest.vue?vue&type=style&index=0&id=45d87748&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d87748",
  null
  
)

export default component.exports